<div class="flex w-full h-full justify-center items-center">
  <div class="flex justify-center flex-col w-full items-center gap-2">
    <div class="rounded-md h-10 w-10 border-4 border-t-4 border-[#a3c5dc] animate-spin"></div>
    <p class="blinking-text">Загружаем данные...</p>
  </div>
</div>
